<div class="page-title animatedBackground">
    <div class="container">
        <h3>Blog</h3>
        <ul>
            <li><a routerLink="/">Home</a></li>
            <li class="dot-divider"></li>
            <li>Manage Blogs</li>
        </ul>
    </div>
    <div class="bg-pattern"><img src="assets/img/bg-pattern-2.png" alt="pattern"></div>
</div>

<section class="contact-area ptb-50">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <h3>Add Blogs</h3>
            </div>

            <div class="mt-4 col-lg-12 col-md-12">
                <form id="contactForm" [formGroup]="blogForm">
                    <div class="row">
                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input type="text" formControlName="blogTitle" class="form-control"
                                    placeholder="Blog Title">
                                <div class="form-error-message"
                                    *ngIf="blogForm.get('blogTitle')?.invalid && blogForm.get('blogTitle')?.touched">
                                    Blog Title is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input type="text" formControlName="blogSubTitle" class="form-control"
                                    placeholder="Blog Subtitle">
                                <div class="form-error-message"
                                    *ngIf="blogForm.get('blogSubTitle')?.invalid && blogForm.get('blogSubTitle')?.touched">
                                    Blog Subtitle is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input type="text" formControlName="blogCategory" class="form-control"
                                    placeholder="Blog Category">
                                <div class="form-error-message"
                                    *ngIf="blogForm.get('blogCategory')?.invalid && blogForm.get('blogCategory')?.touched">
                                    Blog Category is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input type="text" formControlName="blogTags" class="form-control"
                                    placeholder="Blog Tags">
                                <div class="form-error-message"
                                    *ngIf="blogForm.get('blogTags')?.invalid && blogForm.get('blogTags')?.touched">
                                    Blog Tags is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <label for="formFile" class="form-label">
                                Upload Blog Image
                            </label>
                            <div class="form-group">
                                <input class="form-control" formControlName="blogImagePath" type="file" id="formFile">
                                <div class="form-error-message"
                                    *ngIf="blogForm.get('blogImagePath')?.invalid && blogForm.get('blogImagePath')?.touched">
                                    Blog Image is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <textarea name="message" formControlName="blogDescription" class="form-control"
                                    id="message" cols="30" rows="4" placeholder="Blog Description"></textarea>
                                <div class="form-error-message"
                                    *ngIf="blogForm.get('blogDescription')?.invalid && blogForm.get('blogDescription')?.touched">
                                    Blog Description is required and must be enter valid characters.
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <button type="submit" class="btn btn-primary me-md-3"
                                (click)="clickOnSubmit()">Submit</button>
                            <button type="submit" class="pl-2 btn btn-danger" (click)="clearBlogs()">Clear</button>
                        </div>
                    </div>
                </form>
            </div>

            <div class="mt-5 col-lg-12 col-md-12">
                <table class="table table-bordered table-striped table-hover">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Title</th>
                            <th scope="col">Subtitle</th>
                            <th scope="col">Category</th>
                            <th scope="col">Tags</th>
                            <th scope="col">Description</th>
                            <th scope="col">Image</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let blog of blogsList; let i=index">
                            <th scope="row">{{i+1}}</th>
                            <td>{{blog?.blogTitle}}</td>
                            <td>{{blog?.blogSubTitle}}</td>
                            <td>{{blog?.blogCategory}}</td>
                            <td>{{blog?.blogTags}}</td>
                            <td>{{blog?.blogDescription}}</td>
                            <td class="w-80"><a [href]="blog.blogImagePath" class="btn btn-link">View</a></td>
                            <td class="w-145">
                                <button type="button" class="btn btn-primary btn-sm me-md-2"
                                    (click)="getBlogById(blog?._id)">Edit</button>
                                <button type="button" class="btn btn-danger btn-sm"
                                    (click)="deleteAdminBlog(blog?._id)">Delete</button>
                            </td>
                        </tr>
                        <tr *ngIf="blogsList.length == 0" class="text-center">
                            <td colspan="8">No Data Found.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</section>